import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import type {
	Icon,
	IconListColor,
} from '@valk-nx/components/ui-icon-list/src/lib/icon-list.interface';
import { cn } from '@valk-nx/core/lib/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'vp-icon-list',
	templateUrl: './icon-list.component.html',
	imports: [AngularSvgIconModule, TranslatePipe],
})
export class IconListComponent {
	iconColor = input<IconListColor>('text-dark-primary');
	isHorizontal = input<boolean>(true);
	items = input.required<Icon[]>();
	protected readonly cn = cn;
}
